import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0663a071"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goal-analysis-box-container" }
const _hoisted_2 = { class: "goal-analysis-header" }
const _hoisted_3 = {
  key: 0,
  class: "goal-analysis-text-box"
}
const _hoisted_4 = {
  key: 0,
  "data-test": "goal-analysis-text"
}

import { computed, inject, onMounted, Ref, ref } from "vue";
import axios, { AxiosError } from "axios";
import LoadingSpinner from "../loading-spinner.vue";
import processPromptVars, { getDataContext } from "../smart-scratchpad/process-prompt-vars";
import { renderErrorMessageToClient } from "../smart-scratchpad/variable-error-helpers";
import chat from "../smart-scratchpad/chat";
import { TeamGoalAnalysisApiModel } from "../../api-models";
import { Analytics } from "../../services/analytics/analytics";
import { csContext } from "../../services/cs-context";


export default /*#__PURE__*/_defineComponent({
  __name: 'goal-analysis',
  props: {
    goalId: {},
    goalInput: {},
    prompt: {},
    analysis: {},
    cmsAnalysisType: {}
  },
  emits: ["update:analysis"],
  setup(__props: any, { emit: __emit }) {

const isTeamLead = inject("isTeamAdmin") as Ref<boolean>;

const props = __props;

const emit = __emit;

const text = ref<string>("");
const promptInProgress = ref(false);
const showAnalysis = ref(false);

const isLoading = computed(() => promptInProgress.value);
const goalInput = computed(() => props.goalInput);
const shouldDisplayAnalysis = computed(
  () => showAnalysis.value && (text.value.length > 0 || promptInProgress.value),
);

let dataContext: any = null;

const promptWithGoalInput = computed(() => {
  return `@gpt-4\n\nPlease format your response including string formatting, new lines and bullet points where appropriate. This is the readers written team goal: ${goalInput.value}\n\n${props.prompt}`;
});

async function saveAnalysis() {
  if (!isTeamLead.value) return;
  await axios.post("/api/teamgoalanalysis", {
    goalId: props.goalId,
    goalAnalysis: {
      analysis: text.value,
      analysisType: props.cmsAnalysisType,
    },
  });
}

async function askPrompt(): Promise<void> {
  // const activeVersion = version;
  promptInProgress.value = true;

  if (promptWithGoalInput.value?.trim().length > 0) {
    const { processed, errors } = await processPromptVars(promptWithGoalInput.value, dataContext);

    if (errors.length > 0) {
      const errorMessage = renderErrorMessageToClient(errors);
      text.value = errorMessage.includes("Sorry, I couldn't find any data on")
        ? "This will be available once you have at least two members in your team."
        : errorMessage;

      promptInProgress.value = false;
      return;
    }

    Analytics.action("Ran Goal Analysis", "GoalAnalysisActions", {
      teamLeadId: csContext.user.id,
      teamId: csContext.currentTeam?.id,
      goalId: props.goalId,
    });

    chat(processed, (content) => {
      // if (activeVersion === version) {
      promptInProgress.value = false;
      text.value = content.trim();
      // TODO: ensure that this component gets the analysis type even when an analysis doesn't exist
      emit("update:analysis", text.value, props.cmsAnalysisType);
      // }
    })
      .then((message) => {
        Analytics.action("Completed Goal Analysis", "GoalAnalysisActions", {
          teamLeadId: csContext.user.id,
          teamId: csContext.currentTeam?.id,
          goalId: props.goalId,
        });

        saveAnalysis();
      })
      .catch((e) => {
        text.value = "Sorry, there was an error. Please refresh the page.";
        const error = e as AxiosError;
        const errorMessage = `${error.response?.status}: ${error.response?.statusText}`;

        Analytics.action("Failed Goal Analysis", "GoalAnalysisActions", {
          teamLeadId: csContext.user.id,
          teamId: csContext.currentTeam?.id,
          goalId: props.goalId,
          error: errorMessage,
        });
      });
  }
}

async function runAnalysis() {
  if (promptInProgress.value) return;
  if (!dataContext) dataContext = getDataContext();
  await askPrompt();
}

function hideAnalysis() {
  showAnalysis.value = false;
}

onMounted(async () => {
  if (props.analysis?.analysis) {
    text.value = props.analysis.analysis;
  } else if ((text.value === "" || text.value.length < 200) && isTeamLead.value) {
    await runAnalysis();
  }
});

return (_ctx: any,_cache: any) => {
  const _directive_markdown = _resolveDirective("markdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.cmsAnalysisType), 1),
      (shouldDisplayAnalysis.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-primary-minus btn-xs",
            type: "button",
            onClick: hideAnalysis,
            "data-test": "hide-analysis-button"
          }, " Hide "))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-primary-plus btn-xs",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showAnalysis.value = true)),
            "data-test": "show-analysis-button"
          }, " Show "))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["goal-analysis-container", { 'center-flex': !shouldDisplayAnalysis.value }])
    }, [
      (shouldDisplayAnalysis.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (!isLoading.value)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, null, 512)), [
                  [_directive_markdown, text.value]
                ])
              : (_openBlock(), _createBlock(LoadingSpinner, {
                  key: 1,
                  type: 'Dots',
                  size: "100px",
                  "data-test": "goal-suggestion-loading"
                }))
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})